//@flow
import { getFormStringValue,getFormBoolValue } from './submitFormData'
import * as submitDataUtil from './submitFormData'
import type { ReducerState$Type } from '../genericFlowTypes'
import type { EditKratosForm$Type } from './flowTypes'

export const transformDataToEditFormData=(data:any,kratos: ReducerState$Type)=>{
    let formData: EditKratosForm$Type = {}
    
    const kratosResultsetData = data['kratosResultset']
    formData.isInvalidDoc = kratosResultsetData['is_invalid_doc']?kratosResultsetData['is_invalid_doc']:false
    
    if (kratosResultsetData['form_type']){
        formData.formType = kratosResultsetData['form_type']
    }
    if (kratosResultsetData['form_service_year']){
        formData.formServiceYear = kratosResultsetData['form_service_year']
    }
    if (kratosResultsetData['form_data']){
        const extractedData = JSON.parse(kratosResultsetData['form_data']) 
       
        if (extractedData["ec"]){
            formData = getEditECFormData(formData,extractedData) 
        }else if (extractedData["rr"]){
            formData = getEditRRFormData(formData,extractedData)
        }else if (extractedData["rrb"]){
            formData = getEditRRBFormData(formData,extractedData)
        }else if (extractedData["rru"]){
            formData = getEditRRUFormData(formData,extractedData)
        }else if (extractedData["exc"]) {
            formData = getEditExcFormData(formData,extractedData)
        }         
    }
    
    return formData
}

const getEditExcFormData=(formData:EditKratosForm$Type, data:any)=> {
    const excData = data['exc']
    
    formData.correspondenceType = excData["correspondenceType"]

    //Property Info.
    const propertyInfo = excData['propertyInfo']
    formData = getPropertyInfoFormData(formData,propertyInfo)

    return formData
}

const getEditECFormData=(formData:EditKratosForm$Type, data:any)=> {
    const ecData = data['ec']
    
    //Property Info.
    const propertyInfo = ecData['propertyInfo']
    formData = getPropertyInfoFormData(formData,propertyInfo)
    
    //Billing Contact
    const billingContact=ecData['billingContact']
    formData.noChanges=billingContact["noChanges"]
    formData.firstName=billingContact["firstName"]
    formData.isFirstNameNotReadable=billingContact["isFirstNameNotReadable"]?billingContact["isFirstNameNotReadable"]:false
    formData.lastName=billingContact["lastName"]
    formData.isLastNameNotReadable=billingContact["isLastNameNotReadable"]?billingContact["isLastNameNotReadable"]:false
    formData.houseNo=billingContact["houseNo"]
    formData.isHouseNoNotReadable=billingContact["isHouseNoNotReadable"]?billingContact["isHouseNoNotReadable"]:false
    formData.streetName=billingContact["streetName"]
    formData.isStreetNameNotReadable=billingContact["isStreetNameNotReadable"]?billingContact["isStreetNameNotReadable"]:false
    formData.apt=billingContact["apt"]
    formData.isAptNotReadable=billingContact["isAptNotReadable"]?billingContact["isAptNotReadable"]:false
    formData.city=billingContact["city"]
    formData.isCityNotReadable=billingContact["isCityNotReadable"]?billingContact["isCityNotReadable"]:false
    formData.state=billingContact["state"]
    formData.isStateNotReadable=billingContact["isStateNotReadable"]?billingContact["isStateNotReadable"]:false
    formData.zipCode=billingContact["zipCode"]
    formData.isZipCodeNotReadable=billingContact["isZipCodeNotReadable"]?billingContact["isZipCodeNotReadable"]:false
    formData.email=billingContact["email"]
    formData.isEmailNotReadable=billingContact["isEmailNotReadable"]?billingContact["isEmailNotReadable"]:false
    formData.phone=billingContact["phone"]
    formData.isPhoneNotReadable=billingContact["isPhoneNotReadable"]?billingContact["isPhoneNotReadable"]:false
    formData.phoneExt=billingContact["phoneExt"]
    formData.isPhoneExtNotReadable=billingContact["isPhoneExtNotReadable"]?billingContact["isPhoneExtNotReadable"]:false
    formData.poBox=billingContact["poBox"]
    formData.isPoBoxNotReadable=billingContact["isPoBoxNotReadable"]?billingContact["isPoBoxNotReadable"]:false

    //Exemption Request
    const exemptionRequest=ecData['exemptionRequest']
    formData.renewIndicator=exemptionRequest["renewIndicator"]
    formData.renewUnitIndicator=exemptionRequest["renewUnitIndicator"]
    formData.newExemptionIndicator=exemptionRequest["newExemptionIndicator"]
    formData.exemptionCode1=exemptionRequest["exemptionCode1"]
    formData.isExemptionCode1NotReadable=exemptionRequest["isExemptionCode1NotReadable"]?exemptionRequest["isExemptionCode1NotReadable"]:false
    formData.unitAddr1=exemptionRequest["unitAddr1"]
    formData.isUnitAddr1NotReadable=exemptionRequest["isUnitAddr1NotReadable"]?exemptionRequest["isUnitAddr1NotReadable"]:false
    formData.houseId1=exemptionRequest["houseId1"]
    formData.isHouseId1NotReadable=exemptionRequest["isHouseId1NotReadable"]?exemptionRequest["isHouseId1NotReadable"]:false
    formData.streetName1=exemptionRequest["streetName1"]
    formData.isStreetName1NotReadable=exemptionRequest["isStreetName1NotReadable"]?exemptionRequest["isStreetName1NotReadable"]:false
    formData.unitId1=exemptionRequest["unitId1"]
    formData.isUnitId1NotReadable=exemptionRequest["isUnitId1NotReadable"]?exemptionRequest["isUnitId1NotReadable"]:false
    formData.exemptionCode2=exemptionRequest["exemptionCode2"]
    formData.isExemptionCode2NotReadable=exemptionRequest["isExemptionCode2NotReadable"]?exemptionRequest["isExemptionCode2NotReadable"]:false
    formData.unitAddr2=exemptionRequest["unitAddr2"]
    formData.isUnitAddr2NotReadable=exemptionRequest["isUnitAddr2NotReadable"]?exemptionRequest["isUnitAddr2NotReadable"]:false
    formData.houseId2=exemptionRequest["houseId2"]
    formData.isHouseId2NotReadable=exemptionRequest["isHouseId2NotReadable"]?exemptionRequest["isHouseId2NotReadable"]:false
    formData.streetName2=exemptionRequest["streetName2"]
    formData.isStreetName2NotReadable=exemptionRequest["isStreetName2NotReadable"]?exemptionRequest["isStreetName2NotReadable"]:false
    formData.unitId2=exemptionRequest["unitId2"]
    formData.isUnitId2NotReadable=exemptionRequest["isUnitId2NotReadable"]?exemptionRequest["isUnitId2NotReadable"]:false
    formData.exemptionCode3=exemptionRequest["exemptionCode3"]
    formData.isExemptionCode3NotReadable=exemptionRequest["isExemptionCode3NotReadable"]?exemptionRequest["isExemptionCode3NotReadable"]:false
    formData.houseId3=exemptionRequest["houseId3"]
    formData.isHouseId3NotReadable=exemptionRequest["isHouseId3NotReadable"]?exemptionRequest["isHouseId3NotReadable"]:false
    formData.streetName3=exemptionRequest["streetName3"]
    formData.isStreetName3NotReadable=exemptionRequest["isStreetName3NotReadable"]?exemptionRequest["isStreetName3NotReadable"]:false
    formData.unitId3=exemptionRequest["unitId3"]
    formData.isUnitId3NotReadable=exemptionRequest["isUnitId3NotReadable"]?exemptionRequest["isUnitId3NotReadable"]:false

    //Signature
    const signature=ecData['signature']
    formData=getSignatureInfoFormData(formData,signature)
 
    return formData
}

const getSignatureInfoFormData=(formData:EditKratosForm$Type, data:any)=>{
    formData.printedName=getFormStringValue(data,"printedName")
    formData.isPrintNameNotReadable=getFormBoolValue(data,"isPrintNameNotReadable")
    formData.signatureIndicator=getFormStringValue(data,"signatureIndicator")
    formData.signatureDate=getFormStringValue(data,'signatureDate')
    formData.isSignatureDateNotReadable=getFormBoolValue(data,'isSignatureDateNotReadable')

    return formData
}

const getEditRRFormData=(formData:EditKratosForm$Type, data:any)=> {
    const rrData = data['rr']

    //Property Info.
    const propertyInfo = rrData['propertyInfo']
    formData = getPropertyInfoFormData(formData,propertyInfo)
    
    //Emergency Contact Info.
    const emergencyContactInfo = rrData['emergencyContactInfo']
    formData = getEmergencyContactInfoFormData(formData,emergencyContactInfo)
    
    //Registrant Info.
    const registrantInfo = rrData['registrantInfo']
    formData = getRegistrantInfoFormData(formData,registrantInfo)
    
    return formData
}

const getEditRRBFormData=(formData:EditKratosForm$Type, data:any)=> {
    const rrbData = data['rrb']

    //Property Info.
    const propertyInfo = rrbData['propertyInfo']
    formData = getPropertyInfoFormData(formData,propertyInfo)

    //Emergency Contact Info.
    const emergencyContactInfo = rrbData['emergencyContactInfo']
    formData = getEmergencyContactInfoFormData(formData,emergencyContactInfo)

    //Registrant Info.
    const registrantInfo = rrbData['registrantInfo']
    formData = getRegistrantInfoFormData(formData,registrantInfo)

    return formData
}

const getPropertyInfoFormData=(formData:EditKratosForm$Type, data:any)=>{
    formData.apn=data['apn']
    formData.isApnNotFound=getFormBoolValue(data,"isApnNotFound")

    formData.statementNo=data['statementNo'] //RR
    formData.isStatementNotFound==getFormBoolValue(data,"isStatementNotFound") //Rr
    
    if (formData.formType == submitDataUtil.RRB_FORM_TYPE){
        formData.propHouseNumber=getFormStringValue(data,"propHouseNumber")
        formData.isPropHouseNumberNotReadable=getFormBoolValue(data,"isPropHouseNumberNotReadable") 
        formData.propStreetName=getFormStringValue(data,"propStreetName")
        formData.isPropStreetNameNotReadable=getFormBoolValue(data,"isPropStreetNameNotReadable")
        formData.propCity=getFormStringValue(data,"propCity")
        formData.isPropCityNotReadable=getFormBoolValue(data,"isPropCityNotReadable")
        formData.propState=getFormStringValue(data,"propState")
        formData.isPropStateNotReadable=getFormBoolValue(data,"isPropStateNotReadable")
        formData.propZipCode=getFormStringValue(data,"propZipCode")
        formData.isPropZipCodeNotReadable==getFormBoolValue(data,"isPropZipCodeNotReadable")
    }
    
    return formData
}

const getRegistrantInfoFormData=(formData:EditKratosForm$Type, data:any)=>{
    formData.sameInfoCheck=getFormStringValue(data,"sameInfoCheck")
    formData.registrantFirstName=getFormStringValue(data,"registrantFirstName")
    formData.isRegistrantFirstNameNotReadable=getFormBoolValue(data,"isRegistrantFirstNameNotReadable")
    formData.registrantLastName=getFormStringValue(data,"registrantLastName")
    formData.isRegistrantLastNameNotReadable=getFormBoolValue(data,"isRegistrantLastNameNotReadable")
    formData.registrantPhone=data["registrantPhone"]
    formData.isRegistrantPhoneNotReadable=getFormBoolValue(data,"isRegistrantPhoneNotReadable")
    formData.registrantEmail=getFormStringValue(data,"registrantEmail")
    formData.isRegistrantEmailNotReadable=getFormBoolValue(data,"isRegistrantEmailNotReadable")

    return formData
}

const getEmergencyContactInfoFormData=(formData:EditKratosForm$Type, data:any)=>{
    formData.emergencyFirstName=getFormStringValue(data,"emergencyFirstName")
    formData.isEmergencyFirstNameNotReadable=getFormBoolValue(data,"isEmergencyFirstNameNotReadable")
    formData.emergencyLastName=getFormStringValue(data,"emergencyLastName")
    formData.isEmergencyLastNameNotReadable=getFormBoolValue(data,"isEmergencyLastNameNotReadable")
    formData.emergencyHouseNumber=getFormStringValue(data,"emergencyHouseNumber")
    formData.isEmergencyHouseNumberNotReadable=getFormBoolValue(data,"isEmergencyHouseNumberNotReadable")
    formData.emergencyStreetName=getFormStringValue(data,"emergencyStreetName")
    formData.isEmergencyStreetNameNotReadable=getFormBoolValue(data,"isEmergencyStreetNameNotReadable")
    formData.emergencyCity=getFormStringValue(data,"emergencyCity")
    formData.isEmergencyCityNotReadable=getFormBoolValue(data,"isEmergencyCityNotReadable")
    formData.emergencyState=getFormStringValue(data,"emergencyState")
    formData.isEmergencyStateNotReadable=getFormBoolValue(data,"isEmergencyStateNotReadable")
    formData.emergencyZipCode=getFormStringValue(data,"emergencyZipCode")
    formData.isEmergencyZipCodeNotReadable=getFormBoolValue(data,"isEmergencyZipCodeNotReadable")
    formData.emergencyPhone=data["emergencyPhone"] //number
    formData.isEmergencyPhoneNotReadable=getFormBoolValue(data,"isEmergencyPhoneNotReadable")
    formData.emergencyEmail=getFormStringValue(data,"emergencyEmail")
    formData.isEmergencyEmailNotReadable=getFormBoolValue(data,"isEmergencyEmailNotReadable")
    formData.totalUnitsPrinted=getFormStringValue(data,"totalUnitsPrinted")
    formData.isTotalUnitsPrintedNotReadable=getFormBoolValue(data,"isTotalUnitsPrintedNotReadable")
    formData.totalUnitsEntered=data["inputFormData"] //number
    formData.isTotalUnitsEnteredNotReadable=getFormBoolValue(data,"isTotalUnitsEnteredNotReadable")

    return formData
}

const getEditRRUFormData=(formData:EditKratosForm$Type, data:any)=> {
    const rruData = data['rru']

    //Property Info.
    const propertyInfo = rruData['propertyInfo']
    formData = getPropertyInfoFormData(formData,propertyInfo)

    const signatureInfo = rruData['signature'] 
    formData = getSignatureInfoFormData(formData,signatureInfo)   

    const formPageInfo = rruData['formPageInfo']
    formData.formPageNumber=formPageInfo['formPageNumber']
    formData.formPageTotal=formPageInfo['formPageTotal']

    const unitInfo1 = rruData['unitInfo1']
    formData = getUnitInfoFormData(formData,1,unitInfo1)
    const unitInfo2 = rruData['unitInfo2']
    formData = getUnitInfoFormData(formData,2,unitInfo2)
    const unitInfo3 = rruData['unitInfo3']
    formData = getUnitInfoFormData(formData,3,unitInfo3)
    const unitInfo4 = rruData['unitInfo4']
    formData = getUnitInfoFormData(formData,4,unitInfo4)
    const unitInfo5 = rruData['unitInfo5']
    formData = getUnitInfoFormData(formData,5,unitInfo5)

    return formData
}

const getUnitInfoFormData=(formData:any, formIndex:number,data:any)=>{
    const fieldHouseNumber=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixHouseNumber)
    const fieldBoolHouseNumber=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixHouseNumber)
    const fieldStreetName=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixStreetName)
    const fieldBoolStreetName=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixStreetName)
    const fieldUnitNumber=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixUnitNumber)
    const fieldBoolUnitNumber=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixUnitNumber)
    const fieldBedroomCount=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixBedroomCount)
    const fieldBoolBedroomCount=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixBedroomCount)
    const fieldMoveinDate=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixMoveinDate)
    const fieldBoolMoveinDate=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixMoveinDate)
    const fieldMoveinDateCheck=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixMoveinDateCheck)
    const fieldCurrentRent=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixCurrentRent)
    const fieldBoolCurrentRent=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixCurrentRent)
    const fieldLastIncreaseDate=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixLastIncreaseDate)
    const fieldBoolLastIncreaseDate=submitDataUtil.getBoolUnitFieldName(formIndex,submitDataUtil.SuffixLastIncreaseDate)
    const fieldLastIncreaseDateCheck=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixLastIncreaseDateCheck)
    const fieldUtilityPaidByLandlord=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixUtilityPaidByLandlord)
    const fieldIncludeParking=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixIncludeParking)
    const fieldExemptionType=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixExemptionType)
    const fieldTempVacantCheck=submitDataUtil.getUnitFieldName(formIndex,submitDataUtil.SuffixTempVacantCheck)

    formData[fieldHouseNumber]=getFormStringValue(data,fieldHouseNumber)
    formData[fieldBoolHouseNumber]=getFormBoolValue(data,fieldBoolHouseNumber)    
    formData[fieldStreetName]=getFormStringValue(data,fieldStreetName)
    formData[fieldBoolStreetName]=getFormBoolValue(data,fieldBoolStreetName)
    formData[fieldUnitNumber]=getFormStringValue(data,fieldUnitNumber)
    formData[fieldBoolUnitNumber]=getFormBoolValue(data,fieldBoolUnitNumber)
    formData[fieldBedroomCount]=data[fieldBedroomCount]
    formData[fieldBoolBedroomCount]=getFormBoolValue(data,fieldBoolBedroomCount)
    formData[fieldMoveinDate]=getFormStringValue(data,fieldMoveinDate)
    formData[fieldBoolMoveinDate]=getFormBoolValue(data,fieldBoolMoveinDate)
    formData[fieldMoveinDateCheck]=getFormStringValue(data,fieldMoveinDateCheck)
    formData[fieldCurrentRent]=data[fieldCurrentRent]
    formData[fieldBoolCurrentRent]=getFormBoolValue(data,fieldBoolCurrentRent)
    formData[fieldLastIncreaseDate]=getFormStringValue(data,fieldLastIncreaseDate)
    formData[fieldBoolLastIncreaseDate]=getFormBoolValue(data,fieldBoolLastIncreaseDate)
    formData[fieldLastIncreaseDateCheck]=getFormStringValue(data,fieldLastIncreaseDateCheck)
    formData[fieldUtilityPaidByLandlord]=getFormStringValue(data,fieldUtilityPaidByLandlord)
    formData[fieldIncludeParking]=getFormStringValue(data,fieldIncludeParking)
    formData[fieldExemptionType]=getFormStringValue(data,fieldExemptionType)
    formData[fieldTempVacantCheck]=getFormStringValue(data,fieldTempVacantCheck)

    return formData
}


// WEBPACK FOOTER //
// ./src/redux/kratos/editFormData.js